import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
class ActivitiesAddEdit extends React.Component {
  state = {
    is_saving: false,
    action: 'add',
    formData: {
      id: null,
      name_en: '',
      name_ar: '',
      order: '1',
      image: null,
    },
  }

  componentDidMount() {
    if (this.props.match && this.props.match.params) {
      this.setState(
        {
          action: this.props.match.params.action,
          formData: {
            ...this.state.formData,
            id: this.props.match.params.id,
          },
        },
        () => {
          if (this.state.action === 'edit' && this.state.formData.id) {
            this.loadData(this.state.formData.id)
          }
        }
      )
    }
  }

  loadData = async (id) => {
    await axios
      .get(Constant.getAPI() + '/admin/activity/' + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            formData: {
              ...res.data.data,
            },
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
    })
  }

  handleChangeImage = ({ target: { name, files } }) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: files[0],
      },
    })
  }

  onClear = () => {
    this.setState(
      {
        is_saving: false,
        formData: {
          id: this.state.formData.id || null,
          name_en: '',
          name_ar: '',
          order: '1',
          image: null,
        },
      },
      () => {
        this.image_input.value = null
      }
    )
  }

  onSave = () => {
    this.setState({ is_saving: true })

    const formData = new FormData()
    formData.append('name_en', this.state.formData.name_en)
    formData.append('name_ar', this.state.formData.name_ar)
    formData.append('order', this.state.formData.order)

    if (this.state.formData.image && typeof this.state.formData.image == 'object') {
      formData.append('image', this.state.formData.image)
    }

    var request
    if (this.state.action === 'add') {
      request = axios.post(Constant.getAPI() + '/admin/activity', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    } else {
      request = axios.put(Constant.getAPI() + '/admin/activity/' + this.state.formData.id, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    }

    request
      .then((data) => {
        if (data.status === 200 && data.data) {
          Swal.fire({
            title: this.state.action === 'add' ? 'Successfully created.' : 'Successfully updated.',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = `#/activities-master`
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          is_saving: false,
        })
      })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Activity {this.state.action === 'edit' ? ' Edit' : ' Add'}</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/activities-master`}> Activities List</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Activity {this.state.action === 'edit' ? ' Edit' : ' Add'}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-5 col-form-label">Name English</label>
                          <div className="col-md-7">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Name English"
                              value={this.state.formData.name_en}
                              name="name_en"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-5 col-form-label">Name Arabic</label>
                          <div className="col-md-7">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Name Arabic"
                              value={this.state.formData.name_ar}
                              name="name_ar"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-sm-5">Image</div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <div>
                                <input
                                  type="file"
                                  id="img"
                                  name="image"
                                  accept="image/*"
                                  className="w-100"
                                  onChange={this.handleChangeImage}
                                  ref={(ref) => (this.image_input = ref)}
                                />
                              </div>
                            </div>
                            {this.state.formData && this.state.formData.image ? (
                              typeof this.state.formData.image == 'object' ? (
                                <img
                                  width="200px"
                                  height="150px"
                                  src={URL.createObjectURL(this.state.formData.image)}
                                  alt="img"
                                  onError={({ currentTarget }) => {
                                    currentTarget.src = './assets/images/no_image.png'
                                  }}
                                />
                              ) : (
                                <img
                                  width="200px"
                                  height="150px"
                                  src={Constant.getImage() + this.state.formData.image}
                                  alt="img"
                                  onError={({ currentTarget }) => {
                                    currentTarget.src = './assets/images/no_image.png'
                                  }}
                                />
                              )
                            ) : (
                              <img
                                width="200px"
                                height="150px"
                                src="./assets/images/no_image.png"
                                alt="img"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-5 col-form-label">Order No.</label>
                          <div className="col-md-7">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Order No."
                              value={this.state.formData.order}
                              name="order"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="row">
                          <div className="text-right col-6 offset-6">
                            {this.state.is_saving ? (
                              <button
                                className="btn btn-grd-disabled mr-2"
                                disabled
                              >
                                Saving...!
                              </button>
                            ) : (
                              <>
                                <button
                                  onClick={this.onSave}
                                  className="btn hor-grd btn-grd-inverse offset-1"
                                >
                                  <i className="ti-save"></i>
                                  {this.state.action === 'add' ? 'Save' : 'Update'}
                                </button>
                                <button
                                  onClick={this.onClear}
                                  className="btn hor-grd btn-grd-inverse m-l-10"
                                >
                                  Clear
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ActivitiesAddEdit
